// UI
import NavItem from './NavItem';

// Types
export interface Props {
    names: string[];
    activeIndex: number;
    onClick: (index: number) => void;
}

const Navigation = ({ names, activeIndex, onClick }: Props) => {
    const handleClick = (index) => onClick(index);

    return (
        <div className="mb-10 hidden justify-start space-x-4 overflow-x-auto p-px pb-1 sm:flex">
            {names.map((name, index) => (
                <NavItem
                    key={name}
                    index={index}
                    name={name}
                    onClick={handleClick}
                    active={index === activeIndex}
                />
            ))}
        </div>
    );
};

export default Navigation;
